// export const unitMeasureShortText = {
//     pieces: 'шт.',
//     packages: 'уп.',
//     meters: 'м.',
//     centimeters: 'см.',
//     liters: 'л.',
//     milliliters: 'мл.',
// }

export const currencyText = {
    UAH: 'грн',
    USD: '$',
    EUR: '€',
}